var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainDishes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.1493C9.7575 10.5281 6.6 7.72432 4 3.08057M14.77 6.10432C12.225 4.43557 9.12125 5.13307 7.83625 7.66307C6.55125 10.1931 7.5725 13.5968 10.1163 15.2668C12.4188 16.7781 17.4587 18.3406 21.5 14.0118C17.7125 12.3993 17.3125 7.77432 14.77 6.10432Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14.3306C4.45 14.9181 4 15.5868 4 16.2956C4 18.6618 9.0375 20.5806 15.25 20.5806C21.4625 20.5806 26.5 18.6618 26.5 16.2956C26.5 15.5868 26.05 14.9193 25.25 14.3306",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16.8306C26.5 21.3018 23.3675 25.2243 19.9938 27.4331C19.3 27.8881 18.475 28.0806 17.6462 28.0806H12.8538C12.025 28.0806 11.2 27.8881 10.5062 27.4331C7.1325 25.2243 4 21.3018 4 16.8306",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainDishes);
export default __webpack_public_path__ + "static/media/mainDishes.558d22763591c582cc8b800f3d8807ac.svg";
export { ForwardRef as ReactComponent };